export default "__VITE_ASSET__BP$4edOX__"